import SubSection from "./SubSection";
import useLang from "../../hooks/useLang";
import Label from "../../components/Label";
import Switch from "../../components/Switch";
import Input from "../../components/Input";
import DropdownSelector from "../../components/DropdownSelector";

const VariationParametersSection = ({
  variation,
  defaultVariationId,
  parameters,
  getPrice,
  manualPrice,
  onDefaultToggle = () => {},
  onPriceToggle = () => {},
  onPriceChange = () => {},
  wizardParameters = [],
  wizardSelections = {},
  onWizardSelectionChange = () => {},
}) => {
  const lang = useLang();
  return (
    <SubSection>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Switch
          checked={variation?.id === defaultVariationId}
          onChange={onDefaultToggle}
        />
        <div style={{ width: "var(--gap)" }} />
        <Label>{lang("default_variation")}</Label>
      </div>
      <h3>{lang("parameters")}</h3>
      {parameters?.map((parameter) => {
        const key = Object.keys(parameter)[0];
        const value = Object.values(parameter)[0];
        return (
          <div
            key={key}
            style={{ display: "flex", alignItems: "center" }}
          >
            <div style={{ width: "var(--width-20)" }}>
              <Label>{lang(key)}</Label>
            </div>
            <h2>
              {value == null
                ? "—"
                : key === "width"
                ? `${value * 10} mm`
                : value}
            </h2>
          </div>
        );
      })}
      {wizardParameters.map((wizard) =>
        wizard.steps.map((step) => {
          const options = step.options.map((opt) => ({
            id: opt,
            label: opt,
          }));
          const currentValue = wizardSelections[step.id] || step.options[0];
          const selectedOption = options.find((o) => o.id === currentValue) || options[0];

          return (
            <div
              key={step.id}
              style={{ display: "flex", alignItems: "center" }}
            >
              <div style={{ width: "var(--width-20)" }}>
                <Label>{step.label}</Label>
              </div>
              <div style={{ width: "var(--width-32)" }}>
                {options.length > 0 ? (
                  <DropdownSelector
                    options={options}
                    value={selectedOption}
                    noEmpty
                    onChange={(next) =>
                      onWizardSelectionChange(step.id, next.id)
                    }
                  />
                ) : (
                  <span style={{ opacity: 0.5 }}>—</span>
                )}
              </div>
            </div>
          );
        }),
      )}
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ width: "var(--width-20)" }}>
          <Label>{lang("price")}</Label>
        </div>
        {manualPrice ? (
          <div style={{ width: "var(--width-20)" }}>
            <Input
              type="number"
              value={variation?.price}
              onChange={(e) => {
                onPriceChange(e.currentTarget.value);
              }}
            />
          </div>
        ) : (
          <h2>
            {variation?.manualPrice
              ? `${variation?.price} €`
              : `${getPrice({ parameters }).result} €`}
          </h2>
        )}
        <div style={{ width: "var(--gap)" }} />
        <Switch checked={manualPrice} onChange={onPriceToggle} />
        <div style={{ width: "var(--gap)" }} />
        <Label>{lang("manual_price")}</Label>
      </div>
    </SubSection>
  );
};

export default VariationParametersSection;
